import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import BounceLoader from "react-spinners/BounceLoader";
import LoadingOverlay from "../../common/Loader";
import Toaster from "../../components/Toaster";
import Header from "../../common/header";
import Footer from "../../common/footer";
import Sidebar from "../../common/sidebar";
import { downloadExcel } from "react-export-table-to-excel";

import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";

import { api } from "../../Services/index";
import { config } from "./../../Services/Config";
// var apiConfig = require('../../Services/constant.json')[process.env.REACT_APP_ENV || 'dev'];
const { REACT_APP_ENV } = process.env;
var apiConfig = require("../../Services/constant.json")[REACT_APP_ENV.trim()];

//pdf viewer
import AllPagesPDFViewer from "../dcg_viewer_pdf/all-pages";
import SweetAlert from "react-bootstrap-sweetalert";

import { CSVLink } from "react-csv";
// import ReactExport from "react-data-export";
import getRefreshToken from "../../Services/token";
import IdleTimer from "../../common/IdleTimer";
import AttachmentModal from "../../common/attachment";
import AssociateNotes from "../../common/associateNotes";
var momentt = require("moment-timezone");

// var apiConfig = require('../../Services/constant.json')[REACT_APP_ENV.trim()];

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

//   const csvExportHeaders = [
//     { label: "Associate", key: "associatename" },
//     { label: "Total Number of Comfort Guides Created", key: "totalcomfortguide" },
//     { label: "Sketches Made", key: "totalskecthes" },
//     { label: "Comfort Guides Emailed", key: 'totalemail' },
//     { label: "Comfort Guides Printed", key: 'totalprint' }
//   ];

const csvExportHeaders = [
  { label: "Associate", key: "associatename" },
  { label: "Total Guides", key: "totalcomfortguide" },
  { label: "Sketches", key: "totalskecthes" },
  { label: "Email", key: "totalemail" },
  { label: "Batch Email", key: "totalbatchemail" },
  { label: "Printed", key: "totalprint" },
  { label: "Design Appointment", key: "totalappointment" },
  { label: "Follow Up", key: "totaltask" },
];
const header = [
  "Associate",
  "Total Guides",
  "Sketches",
  "Email",
  "Design Appointment",
  "Printed",
  "Follow Up",
];

const loaderStyle = {
  color: "#f3f3f3",
};

class AssociateComparison extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tab: 2,
      markets: [],
      stores: [],
      selectedMarket: 0,
      selectedStore: [],
      toasterMessage: "",
      toasterType: "",
      selectedMarketAllStores: [],
      selectedAssociate: null,
      startDate: moment().subtract(7, "days").format("MM/DD/YYYY"),
      endDate: moment().format("MM/DD/YYYY"),
      dateLabel: "",
      comparisonData: [],
      spinnerColor: "#000000",
      spinnerLoading: false,

      //pdf viewer
      pdfDCGIds: [],
      samplePdfFilesList: [],
      currentPdfFileUrl:
        apiConfig.base_url + "/dcgforms/print?dcgid=1803&type=stream",
      currentPdfFileIndex: 0,
      btnPrevPdfDisabled: true,
      btnNextPdfDisabled: true,
      showPdfPreview: false,
      showResultGrid: true,
      showAttachmentModal: false,
      showHiddenNotesModal: false,
    };

    this.changeMarket = this.changeMarket.bind(this);
    this.changeStore = this.changeStore.bind(this);
    this.handleCalenderEvent = this.handleCalenderEvent.bind(this);
    // this.handleCalenderCallback = this.handleCalenderCallback.bind(this);
    this.showResults = this.showResults.bind(this);

    //pdf viewer
    this.clickPrevPdf = this.clickPrevPdf.bind(this);
    this.clickNextPdf = this.clickNextPdf.bind(this);
    this.closePdfViewer = this.closePdfViewer.bind(this);
  }

  componentDidMount() {
    this.state.diff = moment().utcOffset(moment().format().toString())._offset;
    this.state.timezonelabel = momentt.tz(momentt.tz.guess()).zoneAbbr();
    this.setUserInfo();
    this.getMarketData();
    this.getStoreData(this.state.selectedMarket);
    var searchObj = {
      startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
      endDate: moment(this.state.endDate).format("YYYY-MM-DD"),
      salesrepid: this.state.selectedAssociate,
      storeId: [],
    };
    // this.getComparisonData(this.state.selectedMarket, this.state.selectedStores, this.state.startDate, this.state.endDate);
    this.getComparisonData(searchObj);
  }

  // pdf viewer Prev Next
  clickPrevPdf = () => {
    this.hiddenNotesModal(false);
    this.openAttachmentModal(false);
    let index = this.state.currentPdfFileIndex - 1;
    let disabledPrev = false;
    if (index <= 0) {
      index = 0;
      disabledPrev = true;
    }

    this.setState({
      currentPdfFileIndex: index,
      btnPrevPdfDisabled: disabledPrev,
      btnNextPdfDisabled: false,
      showPdfPreview: true,
    });
  };

  // pdf viewer Prev Next
  clickNextPdf = () => {
    this.hiddenNotesModal(false);
    this.openAttachmentModal(false);
    let index = this.state.currentPdfFileIndex + 1;
    let disabledNext = false;

    if (index === this.state.samplePdfFilesList.length - 1) {
      index = this.state.samplePdfFilesList.length - 1;
      disabledNext = true;
    }

    this.setState({
      currentPdfFileIndex: index,
      btnPrevPdfDisabled: false,
      btnNextPdfDisabled: disabledNext,
      showPdfPreview: true,
    });

    //console.log(this.state);
  };

  clickPrintPdf = () => {
    this.hiddenNotesModal(false);
    this.openAttachmentModal(false);
    window.open(
      this.state.samplePdfFilesList[this.state.currentPdfFileIndex].fileurl,
      "PRINT",
      "height=600,width=800",
    );
  };

  clickDownloadPdf = () => {
    this.hiddenNotesModal(false);
    this.openAttachmentModal(false);
    let url = new URL(
      this.state.samplePdfFilesList[this.state.currentPdfFileIndex].fileurl,
    );
    let params = new URLSearchParams(url.search);
    params.delete("type");
    window.location.href = url.origin + "" + url.pathname + "?" + params;
  };

  // close Pdf Viewer
  closePdfViewer = () => {
    this.setState({
      showPdfPreview: false,
      showResultGrid: true,
    });
  };
  hiddennotes = () => {
    this.state.activeDCGID =
      this.state.samplePdfFilesList[this.state.currentPdfFileIndex].dcgid;
    this.setState({
      showHiddenNotesModal: true,
    });
    this.openAttachmentModal(false);
  };
  openFN = async (dcgid) => {
    this.state.activeDCGID =
      this.state.samplePdfFilesList[this.state.currentPdfFileIndex].dcgid;
    this.setState({ showAttachmentModal: true });
    this.hiddenNotesModal(false);
  };
  viewPDF = (dcgids, e) => {
    e.preventDefault();
    dcgids = dcgids.substring(1, dcgids.length - 1);
    var arrdcgids = dcgids.split(",");
    // console.log('dcgids ' + dcgids);

    const tmpPdfUrls = [];
    this.setState({ pdfDCGIds: arrdcgids }, () => {
      for (let i = 0; i <= arrdcgids.length - 1; i++) {
        tmpPdfUrls.push({
          dcgid: this.state.pdfDCGIds[i],
          fileurl:
            apiConfig.base_url +
            "/dcgforms/print?dcgid=" +
            this.state.pdfDCGIds[i] +
            "&type=stream" +
            "&timezonediff=" +
            this.state.diff +
            "&timezonelabel=" +
            this.state.timezonelabel,
        });
      }
      this.setState(
        {
          samplePdfFilesList: tmpPdfUrls,
          currentPdfFileUrl: tmpPdfUrls[0].fileurl,
          currentPdfFileIndex: 0,
          btnPrevPdfDisabled: true,
          btnNextPdfDisabled: tmpPdfUrls.length <= 1,
          showPdfPreview: true,
          showResultGrid: false,
        },
        () => {
          console.log("set state");
          // console.log(this.state)
        },
      );
    });
  };

  onCancelPdfViewerPopup = () => {
    this.hiddenNotesModal(false);
    this.openAttachmentModal(false);
    this.setState({
      showPdfPreview: false,
      showResultGrid: true,
    });
  };

  setUserInfo = () => {
    var userinfo = JSON.parse(localStorage.getItem("userinfo"));
    if (userinfo) {
      this.setState({
        loginname: userinfo.roleinfo.loginname,
        userloginid: userinfo.roleinfo.userloginid,
        userLoggedIn: true,
      });
    } else {
       localStorage.removeItem("userinfo");
this.props.history.push("/login");
    }
  };

  handleCalenderEvent(event, datepicker) {
    this.setState({
      startDate: moment(datepicker.startDate).format("MM/DD/YYYY"),
      endDate: moment(datepicker.endDate).format("MM/DD/YYYY"),
      dateLabel:
        moment(datepicker.startDate).format("MM/DD/YYYY") +
        " to " +
        moment(datepicker.endDate).format("MM/DD/YYYY"),
    });
  }

  changeMarket(event) {
    this.setState({ selectedMarket: event.target.value });
    this.setState({ selectedStore: [] });
    this.getStoreData(event.target.value);
    this.setState({ selectedAssociate: null });
    // this.setState({selectedMarket: event.target.value});
    // this.getStoreData(event.target.value);
  }

  changeStore(event) {
    // this.setState({selectedStore: event.target.value});

    // var tmpStores = (Number(event.target.value)===0 ? [] : [event.target.value]);
    var tmpStores =
      Number(event.target.value) === 0
        ? this.state.selectedMarketAllStores
        : [event.target.value];
    tmpStores.push();
    this.setState({ selectedStore: tmpStores });
    this.setState({ selectedAssociate: null });
  }

  tabchangeevent = (e) => {
    this.setState({ tab: e });
  };

  getMarketData() {
    try {
      this.setState({ spinnerLoading: true });
      api
        .getMarketData()
        .then((data) => {
          this.setState({
            markets: data.data,
            spinnerLoading: false,
          });
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    } catch (e) {}
  }

  getStoreData(marketId) {
    try {
      this.setState({ spinnerLoading: true });
      api
        .getStoreData(marketId)
        .then((data) => {
          this.setState({
            stores: data.data,
            spinnerLoading: false,
          });

          const arrMarketStoreIds = data.data.reduce(
            (r, c) => (
              r.storeid.push(c.storeid),
              r.marketid.push(c.marketid),
              r
            ),
            { storeid: [], marketid: [] },
          );
          this.setState({ selectedStore: arrMarketStoreIds.storeid });
          this.setState({ selectedMarketAllStores: arrMarketStoreIds.storeid });
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    } catch (e) {}
  }

  hiddenNotesModal = (flag) => {
    this.setState({ showHiddenNotesModal: flag });
  };
  openAttachmentModal = (flag) => {
    this.setState({ showAttachmentModal: flag });
  };

  getComparisonData(searchParam) {
    try {
      // console.log(searchParam);
      this.setState({ spinnerLoading: true });
      // var actionPayload = {startDate:'2021-03-01', endDate: '2021-03-25', salesrepid: null, storeId: []}
      var actionPayload = searchParam;
      api
        .getAssociateComparisonDataPost(actionPayload)
        .then((data) => {
          if (data && data.response && data.response.status == 401) {
            localStorage.removeItem("userinfo");
this.props.history.push("/login");
          } else {
            this.setState({
              comparisonData: data.data.data,
              spinnerLoading: false,
            });
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
          this.setState({
            spinnerLoading: false,
          });
          this.toggleToaster(
            "Failed to retrieve data from the API. Please try again later.",
            "error",
          );
        });
    } catch (e) {}
  }

  getrefreshtoken(actionPayload) {
    getRefreshToken()
      .then((res) => {
        api
          .getAssociateComparisonDataPost(actionPayload)
          .then((data) => {
            this.setState({
              comparisonData: data.data.data,
              spinnerLoading: false,
            });
            this.getMarketData();
            this.getStoreData(this.state.selectedMarket);
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      })
      .catch((err) => {
         localStorage.removeItem("userinfo");
this.props.history.push("/login");
      });
  }

  showResults = () => {
    var searchObj = {};

    // console.log('this.state.selectedStore ');
    // console.log(this.state.selectedStore);

    if (this.state.selectedStore) {
      searchObj["storeId"] = this.state.selectedStore;
    } else {
      searchObj["storeId"] = [];
    }
    if (this.state.selectedAssociate) {
      searchObj["salesrepid"] = this.state.selectedAssociate;
    } else {
      searchObj["salesrepid"] = null;
    }

    if (this.state.startDate) {
      searchObj["startDate"] = moment(this.state.startDate).format(
        "YYYY-MM-DD",
      );
    }
    if (this.state.endDate) {
      searchObj["endDate"] = moment(this.state.endDate).format("YYYY-MM-DD");
    }
    this.getComparisonData(searchObj);
  };

  renderTableHeader() {
    var header = [];
    header =
      this.state.comparisonData[0] && Object.keys(this.state.comparisonData[0]);
    return (
      <tr key="tabheader">
        <th>Associate</th>
        <th>Total Guides</th>
        <th>Sketches</th>
        <th>Email</th>
        <th>Batch Email</th>
        <th>Printed</th>
        <th>Design Appointment</th>
        <th>Follow Up</th>
      </tr>
    );
  }

  renderTableData() {
    return (
      this.state.comparisonData &&
      this.state.comparisonData.map((data, index) => {
        const {
          associatename,
          totalcomfortguide,
          totalskecthes,
          totalemail,
          totalbatchemail,
          totalprint,
          totalappointment,
          totaltask,
          designer_dcgids,
          dcgids,
        } = data;
        return (
          <tr class={associatename == "Total" ? "total" : ""} key={index}>
            <td>{associatename === null ? "" : associatename}</td>
            {/* <td>{(totalcomfortguide===null) ? 0 : totalcomfortguide}</td> */}
            <td>
              {totalcomfortguide === null || totalcomfortguide === "0" ? (
                0
              ) : associatename == "Total" ? (
                totalcomfortguide
              ) : (
                <a
                  href="javascript:void(0);"
                  onClick={(e) => this.viewPDF(dcgids, e)}
                >
                  {" "}
                  {totalcomfortguide}{" "}
                </a>
              )}
            </td>
            <td>{totalskecthes === null ? 0 : totalskecthes}</td>
            <td>{totalemail === null ? 0 : totalemail}</td>
            <td>{totalbatchemail === null ? 0 : totalbatchemail}</td>
            <td>{totalprint === null ? 0 : totalprint}</td>
            <td>
              {totalappointment === null || totalappointment === "0" ? (
                0
              ) : associatename == "Total" ? (
                totalappointment
              ) : (
                <a
                  href="javascript:void(0);"
                  onClick={(e) => this.viewPDF(designer_dcgids, e)}
                >
                  {" "}
                  {totalappointment}{" "}
                </a>
              )}
            </td>
            <td>{totaltask === null ? 0 : totaltask}</td>
          </tr>
        );
      })
    );
  }

  renderTotalData() {
    return (
      <tr class="total" key="totalrow">
        <td>&nbsp;</td>
        <td>0</td>
        <td>0</td>
        <td>0</td>
        <td>0</td>
        <td></td>
        <td></td>
      </tr>
    );
    //     return this.state.comparisonData.total.map((data, index) => {
    //    const { dateTotal, guidesCreatedTotal, guidesCreatedVariationTotal, sketchesMadeTotal, guidesEmailedTotal, guidesPrintedTotal } = data //destructuring
    //    return (
    //       <tr class="total" key={index}>
    //          <td>&nbsp;</td>
    //          <td>{guidesCreatedTotal}</td>
    //          <td>{guidesCreatedVariationTotal}</td>
    //          <td>{sketchesMadeTotal}</td>
    //          <td>{guidesEmailedTotal}</td>
    //          <td>{guidesPrintedTotal}</td>
    //       </tr>
    //    )
    // })
  }
  formatStoreNumber = (number) => {
    return String(number).padStart(3, "0");
  };
  renderTable() {
    return (
      <div id="daily-summary-table">
        <table class="table table-bordered table-striped" id="table-data">
          <thead>{this.renderTableHeader()}</thead>
          <tbody>
            {this.renderTableData()}
            {/* {this.renderTotalData()} */}
          </tbody>
        </table>
      </div>
    );
  }
  toggleToaster(message, type) {
    this.setState({
      toasterMessage: message,
      toasterType: type,
    });

    setTimeout(() => {
      this.setState({
        toasterMessage: null,
        toasterType: undefined,
      });
    }, 4000);
  }
  handleDownloadExcel = () => {
    var obj = {
      associatename: "Associate",
      totalcomfortguide: "Total Guides",
      totalskecthes: "Sketches",
      totalemail: "Email",
      totalbatchemail: "Batch Email",
      totalprint: "Printed",
      totalappointment: "Design Appointment",
      totaltask: "Follow Up",
    };
    var dataInXl = [];
    const header = [
      "Associate",
      "Total Guides",
      "Sketches",
      "Email",
      "Batch Email",
      "Printed",
      "Design Appointment",
      "Follow Up",
    ];
    this.state.comparisonData.map((c, i) => {
      for (var key in obj) {
        if (!dataInXl[i]) {
          dataInXl[i] = [];
          dataInXl[i].push(c[key]);
        } else {
          dataInXl[i].push(c[key]);
        }
      }
    });
    downloadExcel({
      fileName: "Associate_Comparison",
      sheet: "Associate_Comparison",
      tablePayload: {
        header,
        // accept two different data structures
        body: dataInXl || body2,
      },
    });
  };

  render() {
    return (
      <div className="wrapper">
        <LoadingOverlay
          active={this.state.spinnerLoading}
          spinner={<BounceLoader />}
          className={loaderStyle}
        >
          <Header />
          <IdleTimer></IdleTimer>
          {this.state.showHiddenNotesModal && (
            <AssociateNotes
              dcgId={this.state.activeDCGID}
              hiddenNotesModal={this.hiddenNotesModal}
            />
          )}
          {this.state.showAttachmentModal && (
            <AttachmentModal
              dcgId={this.state.activeDCGID}
              openAttachmentModal={this.openAttachmentModal}
            />
          )}
          <Sidebar tab={this.state.tab} tabchangeevent={this.tabchangeevent} />
          <div className="content-wrapper pb-4">
            {this.state.toasterMessage ? (
              <Toaster
                message={this.state.toasterMessage}
                toasterType={this.state.toasterType}
              />
            ) : null}
            {this.state.showResultGrid === true && (
              <section class="content">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-8">
                      <h5>Associate Comparison Report</h5>
                    </div>
                    <div class="col-md-4">
                      <p class="alertStyle">
                        * All the reports are displaying in EST timezone
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <hr />
                    </div>
                  </div>
                  {/* <form name="myform" method="post" action={apiConfig.base_url+'/admin/reports/associatereports'}
                                target="_blank">
                                <input type="hidden" name="startDate" value={moment(this.state.startDate).format("YYYY-MM-DD")} />
                                <input type="hidden" name="endDate" value={moment(this.state.endDate).format("YYYY-MM-DD")} />
                                <input type="hidden" name="type" value={'download'} />
                                { this.state.selectedStore && <input type="hidden" name="storeId" value={this.state.selectedStore.join(',')} />}
                                <input type="hidden" name="salesrepid" value={this.state.associateId} />
                            </form> */}

                  <div class="row">
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>Market</label>
                        <select
                          className="form-control"
                          value={this.state.selectedMarket}
                          onChange={this.changeMarket}
                        >
                          <option value={0}>All</option>
                          {this.state.markets &&
                            this.state.markets.map((market, key) => (
                              <option value={market.marketid}>
                                {market.marketname}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>Store</label>
                        <select
                          className="form-control"
                          value={this.state.selectedStore}
                          onChange={this.changeStore}
                        >
                          <option value={0}>All</option>
                          {this.state.stores &&
                            this.state.stores.map((str, key) => (
                              <option value={str.storeid}>
                                {this.formatStoreNumber(str.naturalstoreid)}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Date Range</label>
                        <div class="input-group">
                          <DateRangePicker
                            onEvent={this.handleCalenderEvent}
                            onChange={this.handleCalenderEvent}
                            onApply={this.handleCalenderEvent}
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                            }}
                          >
                            <input type="text" className="form-control" />
                          </DateRangePicker>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group mt-1 pt-4">
                        <a
                          href="#"
                          onClick={this.showResults}
                          class="btn btn-primary"
                        >
                          Show
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <hr />
                    </div>
                  </div>

                  <div class="row">
                    {/* <div class="col-md-12 text-right">
                            <label>Export : </label>
                            <a href="" class="mr-2"><img src="dist/img/excel-icon.png" title="Export to Excel"/></a>
                            <a href="" class="mr-2"><img src="dist/img/csv-icon.png" title="Export to CSV"/></a>
                            </div>
                            <div class="col-md-12">
                                {this.renderTable()}
                            </div> */}
                    {!(
                      Object.entries(this.state.comparisonData).length === 0
                    ) && (
                      <div class="col-md-12 text-right">
                        <label>Export : &nbsp; </label>
                        <img
                          src="dist/img/excel-icon.png"
                          className="pointer"
                          title="Export to Excel"
                          onClick={() => {
                            this.handleDownloadExcel();
                          }}
                        />
                        {/* <ExcelFile element={<a href="javascript:void(0);" class="mr-2"><img src="dist/img/excel-icon.png" title="Export to Excel" /></a>}>
                                                    <ExcelSheet data={this.state.comparisonData} name="Associate_Comparison">
                                                        <ExcelColumn label="Associate" value="associatename" />
                                                        <ExcelColumn label="Total Guides" value={(col) => (col.totalcomfortguide === null) ? "0" : col.totalcomfortguide} />
                                                        <ExcelColumn label="Sketches" value={(col) => (col.totalskecthes === null) ? "0" : col.totalskecthes} />
                                                        <ExcelColumn label="Email" value={(col) => (col.totalemail === null) ? "0" : col.totalemail} />
                                                        <ExcelColumn label="Batch Email" value={(col) => (col.totalbatchemail === null) ? "0" : col.totalbatchemail} />
                                                        <ExcelColumn label="Printed" value={(col) => (col.totalprint === null) ? "0" : col.totalprint} />
                                                        <ExcelColumn label="Design Appointment" value={(col) => (col.totalappointment === null) ? "0" : col.totalappointment} />
                                                        <ExcelColumn label="Follow Up" value={(col) => (col.totaltask === null) ? "0" : col.totaltask} />
                                                    </ExcelSheet>
                                                </ExcelFile> */}

                        <CSVLink
                          headers={csvExportHeaders}
                          data={this.state.comparisonData.map((row) => ({
                            ...row,
                            totalcomfortguide:
                              row.totalcomfortguide === null
                                ? "0"
                                : row.totalcomfortguide,
                            totalskecthes:
                              row.totalskecthes === null
                                ? "0"
                                : row.totalskecthes,
                            totalemail:
                              row.totalemail === null ? "0" : row.totalemail,
                            totalbatchemail:
                              row.totalbatchemail === null
                                ? "0"
                                : row.totalbatchemail,
                            totalprint:
                              row.totalprint === null ? "0" : row.totalprint,
                            totalappointment:
                              row.totalappointment === null
                                ? "0"
                                : row.totalappointment,
                            totaltask:
                              row.totaltask === null ? "0" : row.totaltask,
                          }))}
                          filename="Associate_Comparison.csv"
                        >
                          <img
                            src="dist/img/csv-icon.png"
                            title="Export to CSV"
                          />
                        </CSVLink>
                      </div>
                    )}
                    {!(
                      Object.entries(this.state.comparisonData).length === 0
                    ) && <div class="col-md-12">{this.renderTable()}</div>}
                    {Object.entries(this.state.comparisonData).length === 0 && (
                      <div class="col-md-12">Sorry, No Records found!</div>
                    )}
                  </div>
                </div>
              </section>
            )}

            {/* PDF VIEWER */}
            {/* {(this.state.showPdfPreview === true) && (
                            <section class="content">


                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="row col-md-12">
                                            <h5 class="col-md-2"  style={{textAlign:'left',color:'#2470af',cursor:'pointer'}} onClick={this.closePdfViewer}>&lt; Back to Report</h5><h4 class="col-md-8" style={{textAlign:'center'}}>DCG Viewer</h4><h5 class="col-md-2"  style={{textAlign:'left',color:'#2470af',cursor:'pointer'}}></h5><hr /></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            &nbsp;<br></br>&nbsp;
                                        </div>
                                        <div class="col-md-3"></div>
                                        <div class="col-md-3"></div>
                                        <div class="col-md-2"></div>

                                    </div>

                                    <div class="row">
                                        <div class="col-md-6">
                                            <button onClick={this.clickPrevPdf} disabled={this.state.btnPrevPdfDisabled} class="btn btn-primary">&lt;&lt; Prev</button>
                                        </div>

                                        <div class="col-md-6" style={{ textAlign: 'right' }}>
                                            <button onClick={this.clickNextPdf} disabled={this.state.btnNextPdfDisabled} class="btn btn-primary">Next &gt;&gt;</button>
                                        </div>


                                    </div>

                                    <div class="col-md-12 react-pdf__Document_p">
                                        <AllPagesPDFViewer pdf={this.state.samplePdfFilesList[this.state.currentPdfFileIndex].fileurl} />
                                    </div>
                                </div>


                            </section>

                        )} */}

            {this.state.showPdfPreview === true && (
              <SweetAlert
                showConfirm={false}
                onCancel={this.onCancelPdfViewerPopup}
                style={{
                  color: "#000000",
                  fontSize: "11px",
                  minWidth: "80%",
                  marginTop: "30px",
                }}
                closeOnClickOutside={true}
                allowEscape={true}
                btnSize={"sm"}
                customClass="containerBox"
              >
                {/* <div class="row">
                            <div class="col-md-12">
                                <h5>DCG Viewer</h5>
                                <hr />
                            </div>
                            </div> */}
                <div class="row">
                  <div class="col-md-12">
                    <h5
                      style={{
                        textAlign: "right",
                        color: "#2470af",
                        cursor: "pointer",
                        fontSize: "28px",
                      }}
                      onClick={this.onCancelPdfViewerPopup}
                    >
                      {" "}
                      <i class="fas fa-times"></i>
                    </h5>
                  </div>
                  {/* <div class="col-md-12" style={{textAlign:'center'}}>
                                    <h4 >DCG Viewer</h4>
                                    </div> */}
                </div>
                <div class="row">
                  <div class="col-md-2"></div>
                  <div class="col-md-8" style={{ textAlign: "center" }}>
                    <h4>DCG Viewer</h4>
                  </div>
                  <div class="col-md-2" style={{ textAlign: "right" }}>
                    <a>
                      <img
                        src={require("../../dist/img/iconnotes.png")}
                        className="mr-3 notecolor"
                        style={{ marginBottom: 10, cursor: "pointer" }}
                        onClick={this.hiddennotes}
                        data-toggle="modal"
                        data-target="#hiddennotes"
                      />
                    </a>
                    <i
                      onClick={() => {
                        this.openFN();
                      }}
                      className="fa fa-paperclip attachment-pop"
                      style={{ cursor: "pointer" }}
                    ></i>
                    <a
                      href="javascript:void(0);"
                      class="mr-3"
                      onClick={this.clickPrintPdf}
                    >
                      <i className="fas fa-print fa-2x text-color"></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      class="mr-2"
                      onClick={this.clickDownloadPdf}
                    >
                      <i className="fas fa-download fa-2x text-color"></i>
                    </a>
                  </div>
                </div>
                {/* <div class="row">
                                <div class="row col-md-12">
                                    <h4 class="col-md-10" style={{textAlign:'center'}}>DCG Viewer</h4><h5 class="col-md-2"  style={{textAlign:'right',color:'#2470af',cursor:'pointer'}} onClick={this.onCancelPdfViewerPopup}>Close</h5>
                                </div>
                            </div> */}
                <div class="row">
                  <div class="col-md-6" style={{ textAlign: "left" }}>
                    <button
                      onClick={this.clickPrevPdf}
                      disabled={this.state.btnPrevPdfDisabled}
                      class="btn btn-primary"
                    >
                      &lt;&lt; Prev
                    </button>
                  </div>

                  <div class="col-md-6" style={{ textAlign: "right" }}>
                    <button
                      onClick={this.clickNextPdf}
                      disabled={this.state.btnNextPdfDisabled}
                      class="btn btn-primary"
                    >
                      Next &gt;&gt;
                    </button>
                  </div>
                </div>
                <div class="col-md-12">
                  &nbsp;<br></br>&nbsp;
                </div>
                <div class="col-md-12 react-pdf__Document_p">
                  <AllPagesPDFViewer
                    pdf={
                      this.state.samplePdfFilesList[
                        this.state.currentPdfFileIndex
                      ].fileurl
                    }
                  />
                </div>
              </SweetAlert>
            )}
          </div>
        </LoadingOverlay>
        <Footer />
        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
    );
  }
}
export default withRouter(AssociateComparison);
